import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "absolute z-30 h-10 w-screen bottom-0 flex justify-between mb-2 px-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-10" }, null, -1)

import UndoButton from './UndoButton.vue'
import SwitchButton from './SwitchButton.vue'

export default /*#__PURE__*/_defineComponent({
  props: {
    isLocked: { type: Boolean }
  },
  emits: ['undo', 'switch-pair'],
  setup(__props: any, { emit }) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UndoButton, {
      locked: __props.isLocked,
      onUndo: _cache[0] || (_cache[0] = ($event: any) => (emit('undo')))
    }, null, 8, ["locked"]),
    _createVNode(SwitchButton, {
      onSwitchPair: _cache[1] || (_cache[1] = ($event: any) => (emit('switch-pair')))
    }),
    _hoisted_2
  ]))
}
}

})